<!-- HelpInfoWrapper.vue -->
<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { GetFile } from "./GuideContent_axios";

export default {
  name: "HelpInfoWrapper",
  props: {
    serviceName: { type: String, default: null },
    info: { type: Array, default: () => [] },
  },
  data() {
    return {
      helpData: [],
      loading: false,
    };
  },
  created() {
    this.fetchHelpData();
    this.$root.$on("updateData", this.fetchHelpData);
  },
  beforeDestroy() {
    this.$root.$off("updateData", this.fetchHelpData);
  },
  computed: {
    computedInfo: {
      get() {
        return this.info;
      },
      set(val) {
        this.$emit("update:info", val);
      },
    },
  },

  methods: {
    updateData(newData) {
      this.computedInfo = Array.isArray(newData) ? newData : [];
      this.$forceUpdate();
    },
    fetchHelpData() {
      if (!this.serviceName) {
        this.computedInfo = [];
        return;
      }

      this.loading = true;
      GetFile(this.serviceName)
        .then((data) => {
          this.computedInfo = Array.isArray(data) ? data[0] || [] : [];
        })
        .catch(({ response }) => {
          console.error("خطا در دریافت داده‌های راهنما:", error);
          this.computedInfo = [];
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
